import React from "react";
import PolicyLayout, { Section, PolicyList } from "../../components/storefront/PolicyLayout";

export default function ReturnPolicy() {
  return (
    <PolicyLayout
      testid="return-policy-page"
      heading="Return Policy"
      title="Return Policy | Lecis Auto Glass"
      description="Lecis Auto Glass return policy — return window, eligibility, condition requirements and how to request a return authorization for side mirrors, windshields and backglass."
      canonicalPath="/return-policy"
      updated="June 2026"
    >
      <Section>
        <p>
          We want you to be confident in your purchase. If you need to return an item, please review the
          eligibility and process below. We strongly recommend confirming fitment before ordering — our team
          is happy to verify fitment for you via our Contact &amp; Fitment Help page.
        </p>
      </Section>

      <Section title="Return Window">
        <p>
          Eligible items may be returned within <strong className="text-zinc-100">30 days of delivery</strong>.
          Return requests made after this window may not be accepted.
        </p>
      </Section>

      <Section title="Return Eligibility">
        <PolicyList
          items={[
            "The item must be unused, uninstalled and in its original, resalable condition.",
            "The item must be returned with all original packaging, protective materials, hardware and documentation.",
            "Proof of purchase (order number) is required.",
            "Special-order, custom, or clearance items may be non-returnable — this will be noted on the product page where applicable.",
          ]}
        />
      </Section>

      <Section title="Condition Requirements">
        <p>
          Because auto glass is fragile and fitment-sensitive, returned items are inspected on arrival.
          Items that show signs of installation, damage caused after delivery, missing components, or that
          are not in resalable condition may be refused or subject to a reduced refund.
        </p>
      </Section>

      <Section title="Return Authorization Process">
        <PolicyList
          items={[
            "Contact us at support@lecisautoglass.com with your order number and the reason for the return.",
            "We will review your request and, if eligible, issue a Return Authorization (RA) and return instructions.",
            "Do not ship items back without an RA — unauthorized returns may not be processed.",
            "Pack the item securely (ideally in its original packaging) to prevent damage in transit, and include the RA details.",
            "Once received and inspected, we will process your refund per our Refund Policy.",
          ]}
        />
      </Section>

      <Section title="Return Shipping">
        <p>
          For <strong className="text-zinc-100">approved returns</strong>, Lecis Auto Glass covers the cost
          of return shipping when the item is returned in accordance with this policy. Once your Return
          Authorization (RA) is issued, we will provide a prepaid return shipping label or reimburse the
          agreed return shipping cost.
        </p>
        <PolicyList
          items={[
            "Return shipping is paid by Lecis Auto Glass on approved returns handled according to this policy (RA issued, within the return window, item unused/uninstalled and resalable).",
            "Please use the prepaid label we provide and follow the return instructions so your return qualifies.",
            "Returns that are not authorized, fall outside the return window, or arrive not in resalable condition may not qualify for covered return shipping.",
          ]}
        />
      </Section>

      <Section title="Damaged or Incorrect Items">
        <p>
          If you received a damaged or incorrect item, please see our Shipping Policy for the shipping-damage
          procedure, or contact us right away. We will make it right at no additional cost for verified errors
          or transit damage.
        </p>
      </Section>
    </PolicyLayout>
  );
}
